'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';

import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class ProductionAreasList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'description',
				type: 'string',
				canAdd: true,
				canEdit: true,
			},
		];
		this.settings = {
			name: 'ProductionAreasList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			searchList: {
				canAdd: true,
				canDelete: true,
			},
			translationPath: 'PRODUCTS.PRODUCT_AREAS',
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			endpoint: __endpoints.collection.product.production_areas,
		};
		this.init();
		return this;
	}
}
